import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import {isNextUi} from './uiSwitch';

// Both interfaces live in chunks of their own: the stylesheet of antd 4 is
// global (body, a, h1 …) and must only reach the page with the old one.
// Lädt ein Chunk nicht (Netzwerk, neues Image während die Seite offen ist),
// soll statt einer leeren Seite ein Hinweis stehen.
function bootFailed(error) {
    console.error(error);
    const root = document.getElementById('root');
    if (root) {
        root.textContent = 'SMILEconnect konnte nicht geladen werden. Bitte die Seite neu laden.';
    }
}

if (isNextUi(window._env_)) {
    import('./next/boot').then(m => m.default()).catch(bootFailed);
} else {
    import('./legacyBoot').then(m => m.default()).catch(bootFailed);
}
